import { useMutation } from '@tanstack/react-query';
import { useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

type Params = {
  code: string;
  actionId: string;
  onSuccess?: () => void;
};

export function useReassignActionOwnerRequest({
  code,
  actionId,
  onSuccess,
}: Params) {
  const api = useApi();

  return useMutation<void, ExtendedAxiosError, void>({
    mutationKey: ['issues', code, 'reassign-action-request', actionId],
    mutationFn: () =>
      api.issuesApi.reassignActionRequest(code, actionId).then((r) => r.data),
    onSuccess,
  });
}
